import { ICATPLUS_GET_DOI, useGetEndpoint } from '@edata-portal/icat-plus-api';

import { DOIInfo } from './DOIInfo';
import { convertDataciteToInternal } from './utils/convert';

export function FetchDOIFromICATPlus({ doi }: { doi: string }) {
  const icatplusDOI = useGetEndpoint({
    endpoint: ICATPLUS_GET_DOI,
    params: { doi },
    notifyOnError: false,
  });

  // `useGetEndpoint` throws in case of error response, so data is always defined
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return <DOIInfo doi={convertDataciteToInternal(icatplusDOI!)} />;
}
